import { render, staticRenderFns } from "./hotTag.vue?vue&type=template&id=ed33093c&scoped=true&"
import script from "./hotTag.vue?vue&type=script&lang=js&"
export * from "./hotTag.vue?vue&type=script&lang=js&"
import style0 from "./hotTag.vue?vue&type=style&index=0&id=ed33093c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed33093c",
  null
  
)

export default component.exports